import { CRUDPathSegmentEn } from '@martech-solution/utils/constants';

const inventoryPath = {
  inventory: '/erp/inventory',

  // BinLocation -
  binLocation: '/erp/inventory/bin-location',
  binLocationDetail: '/erp/inventory/bin-location' + CRUDPathSegmentEn.DETAIL,
  binLocationAdd: '/erp/inventory/bin-location' + CRUDPathSegmentEn.ADD,
  binLocationEdit: '/erp/inventory/bin-location' + CRUDPathSegmentEn.EDIT,
  binLocationQR: '/erp/inventory/bin-location' + CRUDPathSegmentEn.QR,

  // inventoryJournal- Xem tồn kho hiện tại
  inventoryJournal: '/erp/inventory/inventory-journal',

  // GRPOR - Yêu cầu nhập kho
  grpor: '/erp/inventory/grpor',
  grporDetail: '/erp/inventory/grpor' + CRUDPathSegmentEn.DETAIL,
  grporAdd: '/erp/inventory/grpor' + CRUDPathSegmentEn.ADD,
  grporEdit: '/erp/inventory/grpor' + CRUDPathSegmentEn.EDIT,

  // GRPO - Phiếu nhập kho
  grpo: '/erp/inventory/grpo',
  grpoDetail: '/erp/inventory/grpo' + CRUDPathSegmentEn.DETAIL,
  grpoAdd: '/erp/inventory/grpo' + CRUDPathSegmentEn.ADD,
  grpoEdit: '/erp/inventory/grpo' + CRUDPathSegmentEn.EDIT,

  // ITR - Phiếu yêu cầu chuyển kho
  itr: '/erp/inventory/itr',
  itrDetail: '/erp/inventory/itr' + CRUDPathSegmentEn.DETAIL,
  itrAdd: '/erp/inventory/itr' + CRUDPathSegmentEn.ADD,
  itrEdit: '/erp/inventory/itr' + CRUDPathSegmentEn.EDIT,

  // IT - Phiếu chuyển kho
  it: '/erp/inventory/it',
  itDetail: '/erp/inventory/it' + CRUDPathSegmentEn.DETAIL,
  itAdd: '/erp/inventory/it' + CRUDPathSegmentEn.ADD,
  itEdit: '/erp/inventory/it' + CRUDPathSegmentEn.EDIT
};
export default inventoryPath;
